// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2bHSO","noInteraction":"EventWrapper_noInteraction__SJEnl","pointerPassthrough":"EventWrapper_pointerPassthrough__3K9LB"};